import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { emitUtmifyEvent } from '../../common/utils/emitUtmifyEvent';

/**
 * Página de retorno do Amazon Pay.
 *
 * Após o pagamento na Amazon, o Stripe redireciona de volta para cá com
 * query params: redirect_status, payment_intent, payment_intent_client_secret.
 *
 * redirect_status pode ser: 'succeeded', 'processing', 'requires_payment_method' (falha).
 */
export const AmazonPayReturnTemplate: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectStatus = searchParams.get('redirect_status');
    const vendaId = searchParams.get('vendaId');
    const vendaToken = searchParams.get('vendaToken');
    const snapshotKey = vendaId ? `amazonpay:return:${vendaId}` : null;

    let snapshot: any = null;
    if (snapshotKey) {
      try {
        const raw = sessionStorage.getItem(snapshotKey);
        if (raw) {
          snapshot = JSON.parse(raw);
        }
      } catch (err) {
        console.warn('[AMAZON_PAY_RETURN] Falha ao ler snapshot', err);
      } finally {
        sessionStorage.removeItem(snapshotKey);
      }
    }

    if (redirectStatus === 'succeeded' || redirectStatus === 'processing') {
      const hasState =
        !!snapshot?.purchase &&
        !!snapshot?.checkout &&
        !!vendaId &&
        !!vendaToken;

      if (hasState) {
        const patchedPurchase = {
          ...snapshot.purchase,
          data: {
            ...(snapshot.purchase?.data ?? {}),
            id: vendaId,
            vendaToken,
          },
        };

        navigate('/venda/processando', {
          replace: true,
          state: {
            purchase: patchedPurchase,
            checkout: snapshot.checkout,
            contract: snapshot.contract ?? {},
          },
        });
        return;
      }

      if (vendaId) {
        emitUtmifyEvent({ event: 'refused', vendaId });
        navigate(`/venda/compra-recusada/${vendaId}`, { replace: true });
        return;
      }

      navigate('/venda/recusado', { replace: true });
    } else {
      if (vendaId) {
        emitUtmifyEvent({ event: 'refused', vendaId });
        navigate(`/venda/compra-recusada/${vendaId}`, { replace: true });
      } else {
        navigate(`/venda/recusado`, { replace: true });
      }
    }
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
        color: '#666',
      }}
    >
      <p>Processando seu pagamento...</p>
    </div>
  );
};
